import {refreshToken} from "./AuthService";
import {properties} from "../properties";
import {ftAccessToken, ftRefreshToken} from "../constants/Constants";

export function fetchHomeContent(firstCall) {
    return new Promise((resolve, reject) => {
        const accessToken = localStorage.getItem(ftAccessToken)?.replaceAll('"', '');
        let xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve(JSON.parse(this.responseText));
                } else if (this.status === 403 && firstCall) {
                    // If the token is expired, try to refresh it
                    refreshToken().then(newAccessToken => {
                        localStorage.setItem(ftAccessToken, JSON.stringify(newAccessToken));
                        // Retry the original request with the new access token
                        fetchHomeContent(false).then(resolve).catch(reject);
                    }).catch(() => {
                        localStorage.removeItem(ftAccessToken);
                        localStorage.removeItem(ftRefreshToken);
                        reject({ error: new Error("Failed to refresh token."), status: 403 });
                    });
                } else {
                    reject(new Error("Failed to fetch content."));
                }
            }
        };
        xhttp.open("GET", properties.host + "/home/content", true);
        xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhttp.setRequestHeader("Authorization", "Bearer " + accessToken);
        xhttp.send();
    });
}

export function fetchUserContent(firstCall) {
    return new Promise((resolve, reject) => {
        const accessToken = localStorage.getItem(ftAccessToken)?.replaceAll('"', '');
        let xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve(JSON.parse(this.responseText));
                } else if (this.status === 403 && firstCall) {
                    // If the token is expired, try to refresh it
                    refreshToken().then(newAccessToken => {
                        localStorage.setItem(ftAccessToken, JSON.stringify(newAccessToken));
                        // Retry the original request with the new access token
                        fetchUserContent(false).then(resolve).catch(reject);
                    }).catch(() => {
                        localStorage.removeItem(ftAccessToken);
                        localStorage.removeItem(ftRefreshToken);
                        reject({ error: new Error("Failed to refresh token."), status: 403 });
                    });
                } else {
                    reject(new Error("Failed to fetch content."));
                }
            }
        };
        xhttp.open("GET", properties.host + "/users/userinfo", true);
        xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhttp.setRequestHeader("Authorization", "Bearer " + accessToken);

        xhttp.send();
    });
}

export function fetchAdminContent(firstCall) {
    return new Promise((resolve, reject) => {
        const accessToken = localStorage.getItem(ftAccessToken)?.replaceAll('"', '');
        let xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve(JSON.parse(this.responseText));
                } else if (this.status === 403 && firstCall) {
                    // If the token is expired, try to refresh it
                    refreshToken().then(newAccessToken => {
                        localStorage.setItem(ftAccessToken, JSON.stringify(newAccessToken));
                        // Retry the original request with the new access token
                        fetchAdminContent(false).then(resolve).catch(reject);
                    }).catch(() => {
                        localStorage.removeItem(ftAccessToken);
                        localStorage.removeItem(ftRefreshToken);
                        reject({ error: new Error("Failed to refresh token."), status: 403 });
                    });
                } else {
                    reject(new Error("Failed to fetch admin content."));
                }
            }
        };
        xhttp.open("GET", properties.host + "/admin/all", true);
        xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhttp.setRequestHeader("Authorization", "Bearer " + accessToken);

        xhttp.send();
    });
}

export function changeUserRole(email, role, firstCall) {
    return new Promise((resolve, reject) => {
        const request = {
            "email": email,
            "role": role,
        }
        const accessToken = localStorage.getItem(ftAccessToken)?.replaceAll('"', '');
        let xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve(JSON.parse(this.responseText));
                } else if (this.status === 403 && firstCall) {
                    // If the token is expired, try to refresh it
                    refreshToken().then(newAccessToken => {
                        localStorage.setItem(ftAccessToken, JSON.stringify(newAccessToken));
                        // Retry the original request with the new access token
                        changeUserRole(email, role, false).then(resolve).catch(reject);
                    }).catch(() => {
                        localStorage.removeItem(ftAccessToken);
                        localStorage.removeItem(ftRefreshToken);
                        reject({ error: new Error("Failed to refresh token."), status: 403 });
                    });
                } else {
                    reject(new Error("Failed to change role."));
                }
            }
        };
        xhttp.open("PUT", properties.host + "/admin/change-role", true);
        xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhttp.setRequestHeader("Authorization", "Bearer " + accessToken);

        xhttp.send(JSON.stringify(request));
    });
}